var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0C22.4283 0 0 22.4305 0 50C0 77.5695 22.4283 100 50 100C77.5717 100 100 77.5695 100 50C100 22.4305 77.5717 0 50 0ZM50 95.8334C24.7273 95.8334 4.1666 75.2727 4.1666 50C4.1666 24.7273 24.7273 4.1666 50 4.1666C75.2727 4.1666 95.8334 24.7273 95.8334 50C95.8334 75.2727 75.2727 95.8334 50 95.8334Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8771 48.2422L40.7105 29.4922C40.0717 29.0752 39.2457 29.0527 38.5865 29.4148C37.915 29.7811 37.5 30.4811 37.5 31.2439V68.7439C37.5 69.5068 37.915 70.2068 38.5865 70.573C38.8957 70.742 39.2416 70.8273 39.5834 70.8273C39.974 70.8273 40.3688 70.7174 40.7105 70.4957L69.8771 51.7457C70.4713 51.3633 70.8334 50.702 70.8334 49.9939C70.8334 49.2859 70.4713 48.6248 69.8771 48.2422ZM41.6666 64.9271V35.0607L64.8967 49.9939L41.6666 64.9271Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.339990cfc33ad191d64db33874f45e2e.svg";
export { ForwardRef as ReactComponent };